module.exports = __webpack_public_path__ + "static/img/renzheng.eafe5b01.png";